<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Gerenciar Configurações</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
          <b-form v-on:submit.prevent="onSubmit">
            <b-row>
              <b-col cols="12">
                <b-form-group label="URL da plataforma EAD:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Url"
                                  v-model="$v.form.url_ead.$model"
                                  :state="chkState('url_ead')"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
         <b-card-footer class="p-12">
          <b-row>
            <b-col md="3">
              <b-button block variant="primary" v-on:click="onSubmit">
                <i class="fa fa-check"></i>&nbsp;
                <span>Salvar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import miniToastr from 'mini-toastr'

miniToastr.init()

const formShape = {
  url_ead: ''
}

export default {
  name: 'Configuracoes',
  components: {
    AuthTemplate,
    VueSelect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      url_ead: {}
    }
  },
  data () {
    return {
      form: Object.assign({}, formShape),
    }
  },
  mounted () {
    this.loadParametros(this.$route.params.id)
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    salvar () {
      let form = this.$v.form
      let arrayData = [{
        'tipo': 'ED',
        'valor': form.url_ead.$model
      }]      

      Vue.http.post('api/parametro', arrayData).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success('Configuração salva com sucesso!', 'Sucesso!', 7000)

        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error(e.body.msg, 'Alerta', 5000)
      })
    },
    loadParametros (id) {
      Vue.http.get('api/parametro').then(response => {
        let data = response.data.data.data
        for(let i in data){
          if(data[i].tipo === 'ED'){
            this.form.url_ead = data[i].valor
          }
        }
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
    img.preview {
        width: 200px;
        background-color: white;
        border: 1px solid #DDD;
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/configuracoes/Configuracao.vue